import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { UserInterface } from "../../utility/interface/api/users/get-user-res";

const initialState: UserInterface = {
  id: "",
  user_id: "",
  is_provider: false,
  is_initialized: false,
  profile: {
    email: "",
    verified_email: false,
    name: "",
    given_name: "",
    family_name: "",
    picture: "",
  },
  credit: "",
  token: {},
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateUserInfo: (state, action: PayloadAction<UserInterface>) => {
      const roles = action.payload.roles || [];
      const is_provider = roles.includes("supplier") || !!action.payload.is_provider;
      return {
        ...action.payload,
        is_provider,
      };
    },
    updateToken: (state, action: PayloadAction<any>) => {
      return { ...state, token: { ...action.payload } };
    },
    updateCredit: (state, action: PayloadAction<string>) => {
      return { ...state, credit: action.payload };
    },
    removeUserInfo: (state) => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  updateCredit,
  updateUserInfo,
  updateToken,
  removeUserInfo,
} = userSlice.actions;

export default userSlice.reducer;
